/**
 * Normalize API sender prompt group shape (camelCase / snake_case)
 * For Media Devoted | Created By Ciro Autiero
 */

import type { SenderPromptGroup } from '../types/campaign-texts.types';

type RawSenderPromptGroup = SenderPromptGroup & {
  orderIndex?: number;
  parentId?: string | null;
};

export function normalizeSenderPromptGroup(
  raw: RawSenderPromptGroup,
): SenderPromptGroup {
  return {
    ...raw,
    order_index: raw.order_index ?? raw.orderIndex ?? 0,
    parent_id: raw.parent_id ?? raw.parentId ?? null,
    prompt: raw.prompt ?? null,
  };
}
